import {
    SET_SUB_ROUTE,
} from "./types";

export const setSubRoute = (route) => (dispatch) => {
    dispatch({
        type: SET_SUB_ROUTE,
        payload: route,
    });
};
